import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DeliverySelect} from "../../models/deliverySelect";
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../models/language";
import {ShippingType} from "../../enums/ShippingType";
import {LANG} from "../../constants/local-storage.contant";
import {CookieUtils} from "../../utils/cookie.utils";

@Component({
  selector: 'app-delivery-select',
  templateUrl: './delivery-select.component.html',
  styleUrls: ['./delivery-select.component.scss', './delivery-select-media.component.scss']
})
export class DeliverySelectComponent {

  @Input() deliverySelect!: DeliverySelect;
  @Output() radioSelected = new EventEmitter<void>();

  constructor(
    private translateService: TranslateService
  ) {

    this.translateService.use(CookieUtils.getCookie(LANG) || Language.HY);
  }

  get isExpress() {
    return this.deliverySelect.deliveryMethod.includes('express');
  }

  get isPickup() {
    return this.deliverySelect.deliveryMethod.includes('pickup');
  }

  selectRadio() {
    this.radioSelected.emit();
  }

  protected readonly ShippingType = ShippingType;
}
